import type { Parcela } from "../Components/Shared/Interfaces/Parcela";
import { ServiceBase } from "./ServiceBase";

export class ParcelaService extends ServiceBase {
  async getAll() {
    return this.get('/api/FormaPagamentos/BuscarParcelas');
  }

  async postItem(item: Parcela) {
    return this.post('/api/FormaPagamentos/AdicionarParcela', item);
  }

  async putItem(item: Parcela) {
    return this.put(`/api/FormaPagamentos/AtualizarParcela/${item.id}`, item);
  }

  async postDeleteItem(id: number) {
    return this.delete(`/api/FormaPagamentos/DeletarParcela/${id}`);
  }
} 